import { render, staticRenderFns } from "./DatosAgente.vue?vue&type=template&id=c36ef536&scoped=true"
import script from "./DatosAgente.vue?vue&type=script&lang=js"
export * from "./DatosAgente.vue?vue&type=script&lang=js"
import style0 from "./DatosAgente.vue?vue&type=style&index=0&id=c36ef536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36ef536",
  null
  
)

export default component.exports